import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isUploadable: false,
};

const attachmentsReducerSlice = createSlice({
	name: 'attachmentsReducer',
	initialState,
	reducers: {
		setAttachmentProperties(state, action) {
			return { ...action.payload };
		},
	},
});

export const { setAttachmentProperties } = attachmentsReducerSlice.actions;
export default attachmentsReducerSlice.reducer;
